import { Xmark } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text } from "@gravity-ui/uikit";

import { ProductFilters } from "../../../ProductFilters";

interface FiltersContentProps {
  isModal?: boolean;
  onClose: () => void;
}

export const FiltersContent = ({ isModal, onClose }: FiltersContentProps) => {
  return (
    <Flex direction="column" gap={1} style={{ padding: 20 }}>
      <Flex justifyContent={"space-between"}>
        <Text variant="subheader-3">Фильтры</Text>
        {isModal && (
          <Button view="flat" onClick={onClose}>
            <Icon data={Xmark} />
          </Button>
        )}
      </Flex>
      <br />
      <ProductFilters />
    </Flex>
  );
};
